import { ContactSection } from "./ContactSection";
import { IdleSection } from "./IdleSection";
import { TextSection } from "./TextSection";
import type { MenuSection, SectionId } from "./types";

export type { MenuSection, SectionId } from "./types";

// TODO: placeholder copy — replace with the real section content.
const HISTORY_BODY =
  "A century of Black life in Seattle's Central District, from the Great Migration to the movements that shaped the neighborhood.";
const FOOD_BODY =
  "The kitchens, corner stores, and cooks feeding the neighborhood, and the traditions they carry with them.";
const EVENTS_BODY =
  "Festivals, block parties, and gatherings that bring the Central District together throughout the year.";

/**
 * Adding a section to the menu means adding one entry here. Entries with a
 * label get a button in the left column, in the order written below.
 */
export const MENU_SECTIONS: Record<SectionId, MenuSection> = {
  idle: {
    Component: IdleSection,
  },
  history: {
    label: "History",
    Component: () => <TextSection title="History" body={HISTORY_BODY} />,
  },
  food: {
    label: "Food",
    Component: () => <TextSection title="Food" body={FOOD_BODY} />,
  },
  events: {
    label: "Events",
    Component: () => <TextSection title="Events" body={EVENTS_BODY} />,
  },
  contact: {
    label: "Contact",
    Component: ContactSection,
  },
};

/** The sections that get a button, in menu order. */
export const MENU_LINKS = (
  Object.keys(MENU_SECTIONS) as SectionId[]
).filter((id) => MENU_SECTIONS[id].label !== undefined);
